<div class="package-air-detail-cont" #container>
  <div class="cont-detail-section" #bodyContainer>
    <ng-container *ngTemplateOutlet="contentSwitch"></ng-container>
  </div>
</div>

<ng-template #contentSwitch>
  <ng-container [ngSwitch]="viewType">
    <ng-container *ngSwitchCase="packageBookingDetailViewType.HOTEL">
      <ng-container *ngTemplateOutlet="reservationItinerary"></ng-container>
      <div class="payment hotel">
        <ng-container *ngTemplateOutlet="paymentTemplate"></ng-container>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="packageBookingDetailViewType.AIR">
      <ng-container *ngTemplateOutlet="airSectors"></ng-container>
      <div class="payment air">
        <ng-container *ngTemplateOutlet="paymentTemplate"></ng-container>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="packageBookingDetailViewType.SIMPLE">
      <ng-container *ngTemplateOutlet="simpleCombineView"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #simpleCombineView>
  <div class="air-detail-cont">
    <ng-container *ngTemplateOutlet="airSmallDetail"></ng-container>
  </div>
  <div class="hotel-detail-cont">
    <ng-container *ngTemplateOutlet="hotelSmallDetail"></ng-container>
  </div>
  <div class="payment">
    <ng-container *ngTemplateOutlet="paymentTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #paymentTemplate>
  <app-package-payment-detail
    [passengerArrangement]="passengerArrangement"
    [price]="packagePrice"
    [conversionRate]="conversionRate"
    [productReference]="airValidation?.TripOption?.ProductReference">
  </app-package-payment-detail>
</ng-template>

<ng-template #airSmallDetail>
  <ng-container *ngIf="!!airValidation">
    <p class="section-title">
      {{'PACKAGES_MODULES.PACKAGE_BOOKING.AIR_BOOK_DETAIL' | transloco}}
    </p>
    <app-flight-small-reservation
      [validationVm]="airValidation | airValidationVm"
      [summaryProvider]="travelDetailProvider"
      (showMoreInfo)="showMoreAirInfoEvent($event)">
    </app-flight-small-reservation>
  </ng-container>
</ng-template>


<ng-template #hotelSmallDetail>
  <ng-container *ngIf="hotelValidation?.HotelReservation as hotelReservation">
    <p class="section-title">
      {{'PACKAGES_MODULES.PACKAGE_BOOKING.HOTEL_BOOK_DETAIL' | transloco}}
    </p>
    <app-hotel-small-reservation
      [hotelReservation]="hotelValidation?.HotelReservation"
      (showMoreInfo)="showMoreHotelInfo.emit()">
    </app-hotel-small-reservation>
  </ng-container>
</ng-template>

<ng-template #airSectors>
  <div class="sector-cont" *ngFor="let sector of airValidationSector; index as i">
    <span>
      <p class="type">{{flightType(sector)}}</p>
      <p class="date">{{flightDepartureDate(sector) | date:'EEEE, d MMM yyyy'|  dateFormat }}</p>
      <p class="trip">{{flightTrip(sector)}}</p>
    </span>
    <div class="flight-sector-info">
      <ng-container *ngFor="let flight of sector.Flights; index as i">
        <app-travel-info
          [isMobile]="true"
          [airlineCode]="flight.AirlineCode"
          [airlineName]="flight.AirlineName"
          [opAirlineCode]="flight.OpAirlineCode"
          [opAirlineName]="flight.OpAirlineName"
          [number]="flight.Number"
          [flightTimeInternal]="flight.FlightTimeInternal"
          [departureDate]="flight.DepartureDate"
          [departureAirport]="flight.DepartureAirport"
          [arrivalDate]="flight.ArrivalDate"
          [arrivalAirport]="flight.ArrivalAirport"
          [airplane]="flight.Equipment"
          [travelInfoProvider]="travelDetailProvider"
          [flightClass]="flightClass"
          [fareFamilies]="flight.FareFamilies"
          [cabin]="flight.Cabin">
          <app-luggage-tooltip
            luggageTooltip
            [handBaggage]="!!flight.HandBaggage"
            [fareFamily]="flight.FareFamilies"
            [fareBasis]="flight.FareBasis"
            [airline]="flight.AirlineCode"
            [baggage]="flight.BaggageRestrictions | luggage"
            [showShadow]="false"
            [showArrow]="false"
            [departureDate]="flight.DepartureDate"
            [departureAirport]="flight.DepartureAirport"
            [arrivalAirport]="flight.ArrivalAirport"
            [isInternational]="isInternational">
          </app-luggage-tooltip>
        </app-travel-info>
        <app-flight-segment-connection
          [hasScales]="hasScales"
          [provider]="provider"
          [isConnectionInDifferentAirport]="flight.IsConnectionInDifferentAirport"
          [isScaleElement]="isScaleElement(sector, i)"
          [numberOfStops]="flight.NumberOfStops"
          [totalDuration]="sector.TotalDuration"
          [technicalStopAirport]="flight.TechnicalStopAirport"
          [technicalStopTime]="flight.TechnicalStopTime"
          [flight]="flightItem(sector, i)"
          [nextFlight]="nextFlightItem(sector, i)">
        </app-flight-segment-connection>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #reservationItinerary>
  <app-hotel-reservation
    [image]="hotelValidation.HotelReservation?.Hotel?.Thumbnail"
    [hotelName]="hotelValidation.HotelReservation?.Hotel?.HotelName"
    [stars]="hotelValidation.HotelReservation?.Hotel?.Category"
    [destinationName]="hotelValidation.HotelReservation?.DestinationName"
    [location]="hotelValidation.HotelReservation?.Hotel?.FullAddress"
    [checkin]="hotelValidation.HotelReservation?.Checkin"
    [checkout]="hotelValidation.HotelReservation?.Checkout"
    [rooms]="hotelValidation.HotelReservation?.Rooms">
  </app-hotel-reservation>
</ng-template>